import { Component, Input, TemplateRef, ContentChild } from '@angular/core';

@Component({
    selector: 'app-listbox-item',
    template: '',
})
export class ListboxItemComponent {
    @Input() record: any;
    @ContentChild(TemplateRef, {static: true}) template!: TemplateRef<any>;
}
